/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import colors from "assets/theme/base/colors";
import { Avatar } from "@mui/material";
import { useEffect, useState } from "react";
import { FaDiscord, FaGlobe, FaInstagram, FaTelegram, FaTwitter } from "react-icons/fa";
import { NetworkBase, NetworkBinanceSmartChain, NetworkEthereum, NetworkSolana, NetworkTron } from "@token-icons/react";

function TokenCards({ token ,handleSelectToken}) {
  const [tokenName, setTokenName] = useState("Fetching...");
  const count = token.chainId.charAt(0).toUpperCase() + token.chainId.slice(1); // Capitalized chain name
  const socialLinks = token.links || [];

 // Fetch token name from Dexscreener API
 useEffect(() => {
  async function fetchTokenName() {
    try {
      const apiUrl = `https://api.dexscreener.com/latest/dex/tokens/${token.tokenAddress}`;
      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data.pairs && data.pairs.length > 0) {
        setTokenName(data.pairs[0].baseToken.name);
      } else {
        setTokenName("Unknown Token");
      }
    } catch (error) {
      console.error("Error fetching token name:", error);
      setTokenName("Unknown Token");
    }
  }

  fetchTokenName();
}, [token.tokenAddress]);

  // Map icons based on social type
  const getIcon = (type) => {
    switch (type) {
      case "Website":
        return <FaGlobe size={12} />;
      case "twitter":
        return <FaTwitter size={12}/>;
      case "telegram":
        return <FaTelegram size={12}/>;
      case "Instagram":
        return <FaInstagram size={12}/>;
      case "discord":
          return <FaDiscord size={12}/>;
      default:
        return null;
    }
  };

  // Map chain logos
  const getChainIcon = (type) => {
    switch (type.toLowerCase()) {
      case "solana":
        return <NetworkSolana size={20}  color="#00ffad"/>;
      case "ethereum":
        return <NetworkEthereum size={20} color="#3c3c3d" />;
      case "base":
        return <NetworkBase size={20}  color="#0052ff"/>;
      case "bsc":
        return <NetworkBinanceSmartChain size={20} color="#F3BA2F" />;
      case "ton":
        return <NetworkTron size={20} color="#0088CC"/>;
      case "sonic":
        return <img src="https://dd.dexscreener.com/ds-data/chains/sonic.png" width={20} height={20} alt="Sonic" />;
      case "pulsechain":
        return <img src="https://dd.dexscreener.com/ds-data/chains/pulsechain.png" width={20} height={20} alt="pulsechain" />;
        
      default:
        return null;
    }
  };

  async function getDexData(token) {
    try {
      const apiUrl = `https://api.dexscreener.com/tokens/v1/${token.chainId}/${token.tokenAddress}`;
      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data && data.length > 0) {
        handleSelectToken(data[0])
      } else {
        handleSelectToken({});
      }
    } catch (error) {
      console.error("Error fetching token dex:", error);
      handleSelectToken({});
    }
  }



  return (
    <Card sx={{ padding: "17px", backgroundColor: "#1a1a1a", color: "white", borderRadius: "12px",cursor:'pointer' }} onClick={() => getDexData(token)} >
      <VuiBox>
        <Grid container alignItems="center">
          {/* Left - Token Image */}
          <Grid item xs={4}>
            <VuiBox display="flex" justifyContent="center">
              <Avatar
                src={token.icon}
                sx={{ width: 60, height: 60, borderRadius: "8px" }}
              />
            </VuiBox>
          </Grid>

          {/* Right - Token Info */}
          <Grid item xs={8}>
            <VuiBox ml={2} lineHeight={1}>
              {/* Token Name */}
              <VuiTypography variant="caption" color="white" fontWeight="bold" sx={{fontSize:"15px"}}>
                {tokenName}
              </VuiTypography>

              {/* Chain Info */}
              <VuiBox display="flex" alignItems="center" py={1} pr={2}>
                {getChainIcon(token.chainId)}
                <VuiTypography variant="caption" fontWeight="bold" ml={1}>
                  {count}
                </VuiTypography>
              </VuiBox>

              {/* Social Links */}
              <VuiBox display="flex">
                {socialLinks.map(({ label,type, url }) => (
                  <VuiBox key={type} component="a" href={url} target="_blank" rel="noreferrer" color="white" pr={1}>
                    {getIcon(type ?? label)}
                  </VuiBox>
                ))}
              </VuiBox>
            </VuiBox>
          </Grid>
        </Grid>
      </VuiBox>
    </Card>
  );
}


// Typechecking props for the MiniStatisticsCard
// TokenCards.propTypes = {
//   token: PropTypes.PropTypes.object()
// };

export default TokenCards;
